<template>
  <div class="w-full h-full">
    <div class="flex items-center mt-5px justify-between">
      <el-select
        popper-class="visualization-select-popper"
        placeholder="巡检类型"
        class="w-4/9"
        v-model="keyWords"
        @change="searchType"
      >
        <el-option
          v-for="(item, index) in typeList"
          :key="'type' + index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <TableButtonGroup :list="['日', '周', '月']" v-model="tabName" @btn-click="tabClick" />
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 90px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnList"
        :key="index"
        :prop="item.prop"
        :label="`${$t(item.label)}`"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column :label="`${$t('告警切片')}`" align="center" v-if="keyWords === 'AI视频识别'">
        <template #default="{ row }">
          <div class="cursor-pointer text-[#00BCC8] text-center" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="searchType(keyWords, true)"
      :pager-count="5"
    >
    </el-pagination>
    <el-image class="w-0 h-0" :src="url" :preview-src-list="srcList"> </el-image>
  </div>
</template>

<script>
import { RobotViewAlarmApi, PatrolApi } from '@wiz-api/huizhou2'
import { SecurityAlarmRecordApi } from '@wiz-api/security-management'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import { isEmpty } from 'lodash'
import { transferSkipCount } from '@/assets/js/TransferPage'
import { AlarmRecordApi } from '@wiz-api/data-box'
import dayjs from 'dayjs'

const securityAlarmRecordApi = new SecurityAlarmRecordApi()
const alarmRecordApi = new AlarmRecordApi()
const robotViewAlarmApi = new RobotViewAlarmApi()
const patrolApi = new PatrolApi()
export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: { TableButtonGroup },
  data() {
    return {
      keyWords: '',
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      showDetailDig: false,
      typeList: [
        { label: '点巡检', value: '点巡检' },
        { label: '机器人巡检', value: '机器人巡检' },
        { label: 'AI视频识别', value: 'AI视频识别' },
        { label: '智能传感器', value: '智能传感器' },
      ],
      tabName: '日',
      currentType: 1,
      tableColumnList: [
        { prop: 'alarmContent', label: '告警内容' },
        { prop: 'alarmLevelName', label: '告警等级' },
        { prop: 'startTime', label: '告警时间' },
      ],
      url: '',
      srcList: [],
      pointAllData: [],
      robotAllData: [],
      alarmLevelObj: {
        0: '正常',
        1: '预警',
        2: '一般告警',
        3: '严重告警',
        4: '危急告警',
      },
    }
  },
  computed: {},
  methods: {
    async searchType(val, isPage) {
      this.tableData = []
      if (!isPage) this.page = this.$options.data().page
      await this.cloudRender?.Marker?.destroyAllMarker()
      switch (val) {
        case '点巡检':
          this.tableColumnList = this.$options.data().tableColumnList
          this.getPointAlarmList()
          this.getPointAlarmList(true)
          break
        case '机器人巡检':
          this.tableColumnList = this.$options.data().tableColumnList
          this.getRobotAlarmList()
          this.getRobotAlarmList(true)
          break
        case 'AI视频识别':
          this.tableColumnList = [
            { prop: 'alarmTypeName', label: '告警类型' },
            { prop: 'identifyTime', label: '告警时间' },
          ]
          this.getAIVideoAlarmList()
          break
        case '智能传感器':
          this.tableColumnList = [
            { prop: 'alarmInfo', label: '告警内容' },
            { prop: 'devidName', label: '所属设备' },
            { prop: 'alarmTime', label: '告警时间' },
          ]
          const { startTime, endTime } = this.startAndEndTime(this.tabName)
          this.getSensorAlarmList(startTime, endTime)
          break
        default:
          break
      }
    },
    startAndEndTime(time) {
      let startTime = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      let endTime = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      if (time === '周') {
        startTime = dayjs().subtract(1, 'week').format('YYYY-MM-DD HH:mm:ss')
        endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      } else if (time === '月') {
        startTime = dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss')
        endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
      return { startTime, endTime }
    },
    async tabClick(value) {
      if (value === '日') {
        this.currentType = 1
      } else if (value === '周') {
        this.currentType = 2
      } else if (value === '月') {
        this.currentType = 3
      }
      this.searchType(this.keyWords)
    },
    lookDetail(row) {
      this.url = row.identifyPicture
      this.srcList = [row.identifyPicture]
      setTimeout(() => {
        const img = document.getElementsByClassName('el-image__preview')[0]
        if (!isEmpty(img)) {
          img.click()
        }
      }, 100)
    },
    closeDig() {
      this.showDetailDig = false
    },
    // 绘制图标
    async drawMarker(deviceDetail, type) {
      await this.cloudRender?.Marker?.destroyAllMarker()
      const backgroundUrl = `data://../apps/markers/inspectionAPicture/${type}.png`
      const pictureOption = {
        id: deviceDetail.id,
        pos: JSON.parse(deviceDetail.position),
        backgroundUrl,
        visible: true,
        nodeOffset: [0, 0],
        imgSize: [41, 59],
        markPosType: 1,
      }
      await this.cloudRender?.Marker?.createByPicture(pictureOption)
    },
    // 获取机器人异常记录
    async getRobotAlarmList(isAll = false) {
      const params = {
        type: this.currentType,
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      }
      if (isAll) {
        params.skipCount = 0
        params.maxResultCount = 999
      }
      const [err, res] = await robotViewAlarmApi.getRobotViewAlarmListSync(params)
      if (!err) {
        if (isAll) {
          this.robotAllData = res.items
          for (let i = 0; i < this.robotAllData.length; i += 1) {
            const element = this.robotAllData[i]
            if (element.position) {
              await this.drawMarker(element, 'robot-abnormal')
            }
          }
        } else {
          this.tableData = res.items.map((it) => {
            it.startTime = dayjs(it.startTime).format('YYYY-MM-DD HH:mm:ss')
            it.alarmLevelName = this.alarmLevelObj[it.alarmLevel]
            return it
          })
          this.page.total = res.totalCount
        }
      }
    },
    // 获取点巡检异常记录
    async getPointAlarmList(isAll = false) {
      const params = {
        index: this.currentType - 1, // Number | 时间  0 - 日，1 - 周，2 - 月
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      }
      if (isAll) {
        params.skipCount = 0
        params.maxResultCount = 999
      }
      const [err, res] = await patrolApi.getPatrolAnomalies(params)
      if (!err) {
        if (isAll) {
          this.pointAllData = res.items
          for (let i = 0; i < this.pointAllData.length; i += 1) {
            const element = this.pointAllData[i]
            if (element.position) {
              await this.drawMarker(element, 'point-inspection-abnormal')
            }
          }
        } else {
          this.tableData = res.items.map((it) => {
            it.alarmContent = it.content
            it.alarmLevelName = it.anomalyLevel
            it.startTime = dayjs(it.startTime).format('YYYY-MM-DD HH:mm:ss')
            return it
          })
          this.page.total = res.totalCount
        }
      }
    },
    // 获取传感器异常记录
    async getSensorAlarmList(startTime, endTime) {
      const [err, res] = await alarmRecordApi.selecAlarmRecordUsingGET({
        endTime, // 结束时间 yyyy-MM-dd HH:mm:ss
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        startTime, // 开始时间 yyyy-MM-dd HH:mm:ss
      })
      if (!err) {
        this.tableData = res.data
        this.page.total = res.page.pageTotal
      }
    },
    // 获取AI视频识别
    async getAIVideoAlarmList() {
      const { startTime: identifyStartTime, endTime: identifyEndTime } = this.startAndEndTime(
        this.tabName
      )
      const params = {
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
        identifyStartTime,
        identifyEndTime,
      }
      const [err, res] = await securityAlarmRecordApi.getList(params)
      if (!err) {
        this.tableData = res.items.map((it) => {
          it.identifyTime = dayjs(it.identifyTime).format('YYYY-MM-DD HH:mm:ss')
          return it
        })
        this.page.total = res.totalCount
      }
    },
    pieChartEvent(event) {
      if (event?.detail?.params.name) {
        this.keyWords = event.detail.params.name.split(' ').join('')
        this.tabClick(this.tabName)
      }
    },
  },
  mounted() {},
  created() {
    window.addEventListener('pieChartProps', this.pieChartEvent)
  },
  async beforeDestroy() {
    await this.cloudRender?.Marker?.destroyAllMarker()
    window.removeEventListener('pieChartProps', this.pieChartEvent)
  },
}
</script>

<style>
</style>
